module.exports = __webpack_public_path__ + "static/media/onePlanLogo.560eee53.svg";